import { History } from 'history';
import { Subject } from 'rxjs';

export type CustomBrowserHistory = History & { beforeListenersFired$: Subject<void> };

// eslint-disable-next-line import/no-mutable-exports
export let history = {} as CustomBrowserHistory;

export function setHistoryService(h: CustomBrowserHistory) {
  history = h;
}
